<div class="d-inline-flex">
  <ncp-button
    #addIllnessButton
    [options]="btnPIOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.conditions.nausea.src"
      width="18"
      height="18"
      alt="Add Past Illness"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="past_illness_form"
      name="past_illness_form"
      [formGroup]="form"
      #piFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-dropdown #illnessDesc [(options)]="illnessDescDDOptions" />
      <ncp-date #onSetDate [(options)]="onSetDateOptions" />
      <ncp-date #endDate [(options)]="endDateOptions" />
      <ncp-text-area [(options)]="resolutionsOptions" />
      <ng-template #illnessTemplate let-value>
        <div class="d-flex flex-row">
          <div class="col-6 text-wrap">{{ value.code }}</div>
          <div class="col-6 text-wrap">{{ value.description }}</div>
        </div>
      </ng-template>
    </form>
  </ncp-modal>
</div>
